import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadPlatform } from '@elec/platform';
import { App } from './App.tsx';
import './styles.css';

const platform = await loadPlatform();
// Web: work offline once loaded (service worker). Not in the desktop app, not in development.
if (platform.kind === 'web' && import.meta.env.PROD && 'serviceWorker' in navigator)
  void navigator.serviceWorker.register('./sw.js').catch(() => undefined);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App platform={platform} />
  </StrictMode>,
);
